module.exports = __webpack_public_path__ + "img/symptom.30f1e3ba.svg";